import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { BaseService } from "app/core/base.service";
import { Observable } from "rxjs";
import { ModuloTpwCobranca } from "../models/moduloTpwCobranca.model";
import { ViewModelFiltraCobranca } from "../models/viewModelFiltraCobranca.model";
import { ViewModelRetornaCobrancaSintetica } from "../models/viewModelRetornaCobrancaSintetica.model";
import { ViewModelRetornoCobranca } from "../models/viewModelRetornoCobranca.model";
import { ApiService } from "./api.services";

export class WebCobrancaService extends ApiService implements BaseService<ViewModelFiltraCobranca>{

    private strAction = 'api/WebCobranca';
    dialogData: any;

    constructor(
        httpClient: HttpClient,
        private route: Router) {
        super(httpClient, route);
    }

    getAll() {
        return this.get<any>(this.strAction + `/GetAll`);
    }
    getById(id: number): Observable<ViewModelFiltraCobranca> {
        return this.get<ViewModelFiltraCobranca>(this.strAction + `/GetById/${id}`);
    }

    deleteById(id: number) {
        return this.post(this.strAction + `/DeleteById?id=${id}`);
    }

    filtraCobranca(viewModelFiltraCobranca: ViewModelFiltraCobranca) {
        return this.post<ViewModelRetornoCobranca[]>(this.strAction + `/FiltraCobranca`, viewModelFiltraCobranca);
    }

    filtraCobrancaSintetica(viewModelFiltraCobranca: ViewModelFiltraCobranca) {
        return this.post<ViewModelRetornaCobrancaSintetica[]>(this.strAction + `/FiltraCobrancaSintetica`, viewModelFiltraCobranca);
    }

    filtraModuloCobranca(){
        return this.get<ModuloTpwCobranca[]>(this.strAction + '/FiltraModuloCobranca');
    }


}